// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"Household_sidebarContainer__sELIA","main":"Household_main__iSrlK","sectionContainer":"Household_sectionContainer__Ty5h9"};